import React, { useEffect, Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import {
  Box,
  Link,
  Card,
  InputLabel,
  Select,
  MenuItem,
  CardContent,
  makeStyles,
  Grid,
  colors,
  Avatar,
  Icon,
  Typography,
  Button,
  TextField,
  InputAdornment,
  SvgIcon,
  TablePagination,
  Paper,
  FormControl,
  Checkbox,
  FormGroup,
  FormControlLabel,
  ListItemText,
} from '@material-ui/core';

import agm from '../../services/agm';
import Pager from 'src/utils/Pager';

const useStyles = makeStyles((theme) => ({
  root: {

  },
  avatar: {
    marginRight: theme.spacing(2),
    backgroundColor: colors.grey[200],
    width: 58,
    height: 58
  },
  iconoperation: {
    width: 45,
    height: 45
  },
  baroperation: {
    width: '100%',
    minHeight: 65
  }
}));

const ColorCheckbox = withStyles({
  root: {
    marginLeft: 0,
    color: colors.orange[400],
    '&$checked': {
      color: colors.orange[500],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);


const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const getExternalId = () => {
  return (localStorage.getItem('userexternalid') === 'undefined') ? -1 : localStorage.getItem('userexternalid');
}

const defaultOccurenceTypes = {
  corretiva: true,
  preventiva: true,
  avcb: true,
  pendencia: true
}

const defaultDependencies = {
  loaded: false,
  types: [],
  contracts: [],
  regions: [],
  teams: []
}

const Toolbar = ({ icon, item, resultset, resultModes, vision, visions, selectedMode, openCreation, changeFilter, openView, changeCenter }) => {

  const classes = useStyles();

  const [keyword, setKeyword] = useState('');
  const [query, setQuery] = useState(vision);
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState(100);
  const [occurenceTypes, setOccurenceTypes] = useState(defaultOccurenceTypes);
  const [contract, setContract] = useState(3);
  const [teams, setTeams] = useState([]);
  const [regions, setRegions] = useState([]);
  const [teamsId, setTeamsId] = useState([]);
  const [regionsid, setRegionsId] = useState([]);

  const [dependencies, setDependencies] = useState(defaultDependencies);

  const changeContract = (event) => {
    setContract(event.target.value);
    var base = {};
    for (let index = 0; index < dependencies.contracts.length; index++) {
      const element = dependencies.contracts[index];
      if (element.id == event.target.value) {
        base = { lat: parseFloat(element.latitude), lng: parseFloat(element.longitude) };
      }
    }
    setPage(0);
    changeCenter(base);
    changeFilter(
      query,
      keyword,
      0,
      rows,
      event.target.value,
      occurenceTypes,
      teamsId,
      regionsid,
      base);
  }

  const changeOccurenceTypes = (event) => {
    const value = { ...occurenceTypes, [event.target.name]: event.target.checked };
    setOccurenceTypes(value);
    setPage(0);
    changeFilter(
      query,
      keyword,
      0,
      rows,
      contract,
      value,
      teamsId,
      regionsid,
      null);
  }

  const changeTeams = (event) => {
    var ids = [];
    event.target.value.forEach(nome => {
      dependencies.teams.forEach(team => {
        if (team.nome == nome) {
          ids.push(team.id);
        }
      });
    });
    setTeams(event.target.value);
    setTeamsId(ids);
    setPage(0);
    changeFilter(
      query,
      keyword,
      0,
      rows,
      contract,
      occurenceTypes,
      ids,
      regionsid,
      null);
  }

  const changeRegions = (event) => {
    var ids = [];
    event.target.value.forEach(nome => {
      dependencies.regions.forEach(region => {
        if (region.nome == nome) {
          ids.push(region.id);
        }
      });
    });
    setRegions(event.target.value);
    setRegionsId(ids);
    setPage(0);
    changeFilter(
      query,
      keyword,
      0,
      rows,
      contract,
      occurenceTypes,
      teamsId,
      ids,
      null);
  }

  const changeQuery = (event) => {
    setQuery(event.target.value);
    setPage(0);
    changeFilter(
      event.target.value,
      keyword,
      0,
      rows,
      contract,
      occurenceTypes,
      teamsId,
      regionsid,
      null);
  }

  const changeKeyword = (event) => {
    setKeyword(event.target.value);
    setPage(0);
    changeFilter(
      query,
      event.target.value,
      0,
      rows,
      contract,
      occurenceTypes,
      teamsId,
      regionsid,
      null);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    changeFilter(
      query,
      keyword,
      newPage,
      rows,
      contract,
      occurenceTypes,
      teamsId,
      regionsid,
      null);
  };

  const handleChangeRowsPerPage = (event) => {
    var rowsPerPage = parseInt(event.target.value, 10);
    setRows(rowsPerPage);
    setPage(0);
    changeFilter(
      query,
      keyword,
      page,
      rowsPerPage,
      contract,
      occurenceTypes,
      teamsId,
      regionsid,
      null);
  };

  const loadDependencies = ((value) => {
    agm.get('/ocorrencias/agenda/dependencias', {}, {}).then((response) => {
      if (!response.data.error) {
        for (let index = 0; index < response.data.contratos.length; index++) {
          const element = response.data.contratos[index];
          if (element.id == contract) {
            changeCenter({ lat: parseFloat(element.latitude), lng: parseFloat(element.longitude) });
          }
        }
        setDependencies({
          contracts: response.data.contratos,
          types: response.data.tipos,
          teams: response.data.equipes,
          regions: response.data.regioes
        });
      } else {
        return defaultDependencies;
      }
    }).catch((error) => {
      console.error(error);
    })
  });

  useEffect(() => {
    if (!dependencies.loaded) {
      loadDependencies();
    }
    return
  }, []);

  return (
    <Fragment>
      <Box className={classes.baroperation}>

        <Grid container
          className={classes.baroperation}
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid item
            md="auto"
            xs={2}>
            <Avatar variant="rounded"
              className={classes.avatar}
            >
              {<Icon className={classes.iconoperation} component={icon} style={{ color: colors.orange[500] }} ></Icon>}
            </Avatar>

          </Grid>

          <Grid item
            md="auto"
            xs="auto">

            <Typography
              color="primary"
              variant="h5"
            >
              Você esta na área de <b>{<Link color="inherit" href="/sup/main">ASSISTÊNCIA TÉCNICA</Link>}</b>. A operação padrão é <b> {localStorage.getItem('company')}</b>
            </Typography>

            <Typography
              color="secondary"
              variant="h4"
            >
              <b>Agenda</b>
            </Typography>

          </Grid>
        </Grid>
      </Box>

      <Box>
        <Card>
          <CardContent>
            <Grid container
              fullWidth
              direction="row"
              justifyContent="flex-start"
              alignItems="flex-end"
            >
              <Grid item
                md={12}
                xs={12}>

                <Box mb={2}>
                  <Card>
                    <CardContent>
                      <Grid container
                        fullWidth
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        alignContent="flex-start"

                      >
                        <Grid item
                          xs={12}
                        >
                          <Grid container justifyContent="flex-start" spacing={2}>
                            <Grid item
                              md={3}
                              xs={12}>

                              <FormControl variant="outlined" fullWidth>
                                <InputLabel shrink htmlFor="contract">Contratos</InputLabel>
                                <Select notched
                                  required={true}
                                  fullWidth={true}
                                  label="Contratos"
                                  variant="outlined"
                                  id="contract"
                                  name="contract"
                                  value={contract}
                                  onChange={changeContract}
                                  inputProps={{
                                    name: 'contract',
                                    id: 'contract',
                                  }}
                                >
                                  <MenuItem key={-1} value={-1}>Todos</MenuItem>
                                  {dependencies.contracts.map((contract) => (
                                    <MenuItem key={contract.id} value={contract.id}>{contract.empresa.nome} - {contract.nome}</MenuItem>
                                  ))}

                                </Select>
                              </FormControl>
                            </Grid>

                            <Grid
                              item
                              md={4}
                              xs={12}>
                              <FormGroup row>
                                <FormControlLabel
                                  control={<ColorCheckbox
                                    checked={occurenceTypes.corretiva}
                                    onChange={changeOccurenceTypes} name="corretiva" />}
                                  label="Corretiva"
                                />
                                <FormControlLabel
                                  control={<ColorCheckbox
                                    checked={occurenceTypes.preventiva}
                                    onChange={changeOccurenceTypes} name="preventiva" />}
                                  label="Preventiva"
                                />
                                <FormControlLabel
                                  control={<ColorCheckbox
                                    checked={occurenceTypes.avcb}
                                    onChange={changeOccurenceTypes} name="avcb" />}
                                  label="AVCB"
                                />
                                <FormControlLabel
                                  control={<ColorCheckbox
                                    checked={occurenceTypes.pendencia}
                                    onChange={changeOccurenceTypes} name="pendencia" />}
                                  label="Pendência"
                                />
                              </FormGroup>

                            </Grid>

                            <Grid item
                              md={5}
                              xs={12}
                            >

                              <TablePagination
                                style={{ minWidth: 295 }}
                                variant="caption"
                                component={Paper}
                                className={classes.pager}
                                page={page}
                                rowsPerPage={resultset.rows.length}
                                count={resultset.count}
                                rowsPerPageOptions={[]}
                                labelRowsPerPage={(screen.width <= 480) ? "" : "Linhas por página"}
                                labelDisplayedRows={(screen.width <= 480) ? (({ from, to, count }) => `${from}-${to} de ${count}`) : (({ from, to, count }) => `Encontrados: ${count}, Apresentando de: ${from} a ${to}`)}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                                ActionsComponent={Pager}
                              />

                            </Grid>

                          </Grid>

                        </Grid>

                      </Grid>

                    </CardContent>

                  </Card>
                  
                </Box>

              </Grid>

            </Grid>

          </CardContent>

        </Card>

      </Box>

    </Fragment>

  );
};


Toolbar.propTypes = {
  className: PropTypes.string
};

export default Toolbar;
